import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';

import IconButton from '@mui/material/IconButton';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuIcon from '@mui/icons-material/Menu';
import SecurityIcon from '@mui/icons-material/Security';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import NewIcon from '@mui/icons-material/MenuBook';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { Article, LowPriority, ManageSearch, AssignmentReturn } from '@mui/icons-material';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ListAlt from '@mui/icons-material/ListAlt';
import ReplyIcon from '@mui/icons-material/Reply';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Switch from '@mui/material/Switch';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LanguageIcon from '@mui/icons-material/Language';


/*
menu antiguo antes de la modificacion
const Menu = [
    { label: "Introduccion", path: '#intro', icon: <MenuBookIcon />, subTitle: [{ label: "Antes de empezar", path: '#antesempezar'}, { label: 'La ubicación de ambiente', path: '#ambiente'}] },
    { label: "Autentificacion", path: '#autentificacion', icon: <SecurityIcon />, subTitle: [{ label: "Autorización", path: '#autentificacionTitulo' },{ label: "Access token via resource owner credentials", path: '#autentificacionOwnerCredentials'},{ label: "Access token via refresh token", path: '#autentificacionRefreshToken'}] },
    { label: "Emision", path: '#emision', icon: <FactCheckIcon />, subTitle: [] },
    { label: "EjemplosEmision", path: '#ejemplosemision', icon: <ListAlt />, subTitle: [{ path:'#tiposafectacion' }, { path:'#ejemplostipoafectacion'}, { path:'#ejemplosobjectosjson'}, { path: '#ejemplosarchivos' }] },
    { label: "Detalle", path: '#detalle', icon: <Article />, subTitle: [{label:"Objeto para la creacion de un detalle", path:"#detalleObjeto"},{ label: "Descripcion de los elementos del objeto", path: '#detalleDescripcion'}] },
    { label: "Movimiento", path: '#movimiento', icon: <LowPriority />, subTitle: [{label:"Objeto para la creacion de movimientos", path:"#movimientoObjeto"},{ label: "Descripcion de los elementos del objeto", path: '#movimientoDescripcion'}] },
    { label: "Anulacion", path: '#anulacion', icon: <NotInterestedIcon />, subTitle: [{label:"Anulación de un comprobante", path:"#anulacionComprobante"},{ label: "Objeto para la anulación de un comprobante", path: '#anulacionObjeto'},{ label: "Descripcion de los elementos del objeto", path: '#anulacionDescripcion'}] },
    { label: "Listado", path: '#listcomprobantes', icon: <ListAltIcon />, subTitle: [{label:"Ejemplos de petición para obtener la lista de comprobantes", path:"#listadoComprobante"},{ label: "Respuesta de la peticion", path: '#listadoObjeto'},{ label: "Descripcion de la respuesta", path: '#listadoDescripcion'}] },
    { label: "XML", path: '#xml', icon: <IntegrationInstructionsIcon />, subTitle: [{ label: "XML", path: '#xml' }] },
    { label: "CDR", path: '#cdr', icon: <InboxIcon />, subTitle: [{ label: "CDR", path: '#cdr' }] },
    { label: "Reenviar", path: '#resend', icon: <ReplyIcon />, subTitle: [{label:"Ejemplos de petición para reenviar un comprobante", path:"#reenviarComprobante"},{ label: "Respuesta de la peticion", path: '#reenviarObjeto'},{ label: "Descripcion de la respuesta", path: '#reenviarDescripcion'}] },
    { label: "Recuperar", path: '#recover', icon: <FindInPageIcon />, subTitle: [{label:"Ejemplos de petición para recuperar un comprobante", path:"#recuperarComprobante"},{ label: "Respuesta de la peticion", path: '#recuperarObjeto'},{ label: "Descripcion de la respuesta", path: '#recuperarDescripcion'}] },
    { label: "BuscarProducto", path: '#searchproduct', icon: <ManageSearch />, subTitle: [{ path:"#buscarProducto" },{ path: '#respuestaBuscarProducto' },{ path: '#descripcionParametrosBuscarProducto'}] },
    { label: "RecuperarProducto", path: '#recoverproduct', icon: <AssignmentReturn />, subTitle: [{ path:"#recuperarProducto" },{ path: '#recuperarProductoItem' },{ path: '#recuperarProductoMultipleItem'}, { path: '#recuperarProductoRespuesta'}, { path: '#recuperarProductoDescripcionParametros'}] },
];
*/
const Menu = [
    { label: "Introduccion", path: '#intro', icon: <MenuBookIcon />, subTitle: [{ label: "Introduccion", path: '#intro'}, { label: 'La ubicación de ambiente', path: '#intro'}] },
    //{ label: "Emision", path: '#Emision', icon: <FactCheckIcon />, subTitle: [{ label: "Emision de un comprobante", path: '#emisionComprobante' },{ label: "Objeto para la emision de un comprobante", path: '#emisionObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#emisionDescripcion' }] },
    { label: "Calculos", path: '#calculos', icon: <ListAlt />, subTitle: [{ label: "Objeto para la emision de una Factura", path: '#facturaTitulo' },{ label: "Respuesta de la petición", path: '#facturaObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#facturaDescripcion' }] },
    { label: "Factura", path: '#factura', icon: <LibraryBooksIcon />, subTitle: [{ label: "Objeto para la emision de una Factura", path: '#facturaTitulo' },{ label: "Respuesta de la petición", path: '#facturaObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#facturaDescripcion' }] },
    { label: "Boleta", path: '#boleta', icon: <LibraryBooksIcon />, subTitle:  [{ label: "Objeto para la emision de una Boleta", path: '#boletaTitulo' },{ label: "Respuesta de la petición", path: '#boletaObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#boletaDescripcion' }] },
    { label: "Anulacion", path: '#anulacion', icon: <NotInterestedIcon />, subTitle: [{label:"Anulación de un comprobante", path:"#anulacionComprobante"},{ label: "Objeto para la anulación de un comprobante", path: '#anulacionObjeto'},{ label: "Descripcion de los elementos del objeto", path: '#anulacionDescripcion'}] },
    { label: "XML", path: '#xml', icon: <IntegrationInstructionsIcon />, subTitle: [{ label: "XML", path: '#xml' }] },
    { label: "CDR", path: '#cdr', icon: <InboxIcon />, subTitle: [{ label: "CDR", path: '#cdr' }] },
    { label: "Reenviar", path: '#resend', icon: <ReplyIcon />, subTitle: [{label:"Ejemplos de petición para reenviar un comprobante", path:"#reenviarComprobante"},{ label: "Respuesta de la peticion", path: '#reenviarObjeto'},{ label: "Descripcion de la respuesta", path: '#reenviarDescripcion'}] },
    { label: "Recuperar", path: '#recover', icon: <FindInPageIcon />, subTitle: [{label:"Ejemplos de petición para recuperar un comprobante", path:"#recuperarComprobante"},{ label: "Respuesta de la peticion", path: '#recuperarObjeto'},{ label: "Descripcion de la respuesta", path: '#recuperarDescripcion'}] },
    { label: "BuscarProducto", path: '#searchproduct', icon: <ManageSearch />, subTitle: [{ path:"#buscarProducto" },{ path: '#respuestaBuscarProducto' },{ path: '#descripcionParametrosBuscarProducto'}] },
    { label: "ConsultaApiRuc", path: '#ConsultaApiRuc', icon: <LanguageIcon />, subTitle: [{label:"Consulta RUC Web Service SUNAT", path:"ConsultaApiRuc"},{ label: "Consulta RUC Web Service SUNAT", path: 'ConsultaApiRuc'},{ label: "Descripcion de la respuesta", path: 'ConsultaApiRuc'}] },
];

const EmisionMenu = [
    { label: "Emision", path: '#Emision', icon: <ArrowRightIcon />, subTitle: [{ label: "Emision de un comprobante", path: '#emisionComprobante' },{ label: "Objeto para la emision de un comprobante", path: '#emisionObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#emisionDescripcion' }] },
    { label: "Factura", path: '#factura', icon: <ArrowRightIcon />, subTitle: [{ label: "Objeto para la emision de una Factura", path: '#facturaTitulo' },{ label: "Respuesta de la petición", path: '#facturaObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#facturaDescripcion' }] },
    { label: "Boleta", path: '#boleta', icon: <ArrowRightIcon />, subTitle:  [{ label: "Objeto para la emision de una Boleta", path: '#boletaTitulo' },{ label: "Respuesta de la petición", path: '#boletaObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#boletaDescripcion' }] },
    // { label: "Orden", path: 'orden', icon: <ArrowRightIcon />, subTitle: [{ label: "Objeto para la emision de una Orden", path: '#ordenTitulo' },{ label: "Respuesta de la petición", path: '#ordenObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#ordenDescripcion' }] },
    { label: "Nota de credito", path: '#notaCredito', icon: <ArrowRightIcon />, subTitle:  [{ label: "Objeto para la emision de una Nota de Crédito", path: '#ncTitulo' },{ label: "Respuesta de la petición", path: '#ncObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#ncDescripcion' }] },
    { label: "Nota de debito", path: '#notaDebito', icon: <ArrowRightIcon />, subTitle:  [{ label: "Objeto para la emision de una Nota de Débito", path: '#ndTitulo' },{ label: "Respuesta de la petición", path: '#ndObjeto' },{ label: "Descripcion de los elementos del objeto", path: '#ndDescripcion' }] },
];

const drawerWidth = 240;

const WallpaperSwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 7,
    '& .MuiSwitch-switchBase': {
        margin: 1,
        padding: 0,
        transform: 'translateX(6px)',
        '&.Mui-checked': {
            color: '#fff',
            transform: 'translateX(22px)',
            '& .MuiSwitch-thumb:before': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                    '#fff',
                )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
            },
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
        width: 32,
        height: 32,
        '&:before': {
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
                '#fff',
            )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
        },
    },
    '& .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        borderRadius: 20 / 2,
    },
}));

const ResponsiveDrawer = (props) => {
    const { window, onChangeThemeRapifac } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [selectLanguaje, setSelectLanguaje] = React.useState('es');
    const [t, i18n] = useTranslation('global');
    const [activeArrayMenu, setActiveArrayMenu] = React.useState(Menu.map((e) => e.subTitle))
    const [active, setActive] = React.useState(0);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleClick = () => {
        setOpen(!open);

    };

    const handleChange = (event) => {
        setSelectLanguaje(event.target.value);
        i18n.changeLanguage(event.target.value);
    }

    const handleChangeTheme = (event) => {
        setChecked(event.target.checked);
        onChangeThemeRapifac(event.target.checked);
    }

    const activeSection = (event, index) => {
        setActiveArrayMenu(Menu.map((e) => e.subTitle))
        setActive(index)
    }

    const activeSectionEmision = (event, index) => {
        setActiveArrayMenu(EmisionMenu.map((e) => e.subTitle))
        setActive(index)
    }

    /*
    const drawer = (
        <div>
            <Toolbar />
            <Divider />
            <List>
                {Menu.map((itemMenu, index) => (
                    <React.Fragment key={itemMenu.label}>
                        <ListItem key={itemMenu.label} disablePadding>
                                <ListItemButton
                                    onClick={(event) => itemMenu.label === 'Emision' ? handleClick() : activeSection(event, index)}
                                    component="a"
                                    href={itemMenu.label === 'Emision' ? null : itemMenu.path}
                                >
                                    <ListItemIcon>
                                        {itemMenu.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={t(`nav.${itemMenu.label}`)} />
                                    {itemMenu.label === 'Emision' ? (open ? <ExpandLess /> : <ExpandMore />) : ''}
                                </ListItemButton>
                        </ListItem>
                        {itemMenu.label === 'Emision' ? (
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    {EmisionMenu.map((itemEmisionMenu, index) => (
                                        <ListItemButton key={itemEmisionMenu.label} sx={{ pl: 4 }} href={itemEmisionMenu.path} onClick={(event) => activeSectionEmision(event, index)}>
                                            <ListItemIcon>
                                                {itemEmisionMenu.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={t(`navEmision.${itemEmisionMenu.label}`)} />
                                        </ListItemButton>
                                    ))}
                                </List>
                            </Collapse>
                        ) : ''}
                    </React.Fragment>
                ))}
            </List>
        </div>
    );
    */
    const drawer = (
        <div>
            <Toolbar />
            <Divider />
            <List>
                {Menu.map((itemMenu, index) => (
                    <ListItem key={itemMenu.label} disablePadding>
                        <ListItemButton
                            onClick={(event) => activeSection(event, index)}
                            component="a"
                            href={itemMenu.path}
                        >
                            <ListItemIcon>
                                {itemMenu.icon}
                            </ListItemIcon>
                            <ListItemText primary={t(`nav.${itemMenu.label}`)} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </div>
    );
    
    
    const drawerRight = (
        <div>
            <Divider />
            <List>
                {activeArrayMenu[active].map((element, index) => (
                    <React.Fragment key={index}>
                        <ListItem button href={element.path} component="a">
                            <ListItemText primary={t(`navRight.${element.path}`)} />
                        </ListItem>
                    </React.Fragment>
                ))
                }
            </List>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <>
            <CssBaseline />
            <Box sx={{ display: 'flex', flexGrow: 1 }}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, bgcolor: "#3bafda", py: '1px' }}
                >
                    <Toolbar>
                        <Box display='flex' flexDirection={'row'} justifyContent='center'  alignItems='flex-end'>
                            <Box sx={{ display: { xs: 'none', md: 'flex' }, mt: 1, pt: 0 }}>
                                <img width="150" src="/images/logo-white.png" alt="RAPIFAC" />
                            </Box>
                            <Typography
                                variant="h6"
                                noWrap
                                sx={{
                                    mr: 3,
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: 'monospace',
                                    fontWeight: 700,
                                    letterSpacing: '.3rem',
                                    color: 'white',
                                    textDecoration: 'none',
                                    fontSize: 25,
                                }}
                            >
                                DOCS
                            </Typography>
                        </Box>
                        <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleDrawerToggle}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none' }, mt: 1, pt: 0 }}>
                            <img width="150" src="/images/logo-white.png" alt="RAPIFAC" />
                        </Box>
                        <Typography
                            variant="h5"
                            noWrap
                            component="a"
                            href=""
                            sx={{
                                mr: 2,
                                display: { xs: 'flex', md: 'none' },
                                flexGrow: 1,
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'white',
                                textDecoration: 'none',
                            }}
                        >
                            DOCS
                        </Typography>
                        <Box sx={{ flexGrow: 1 }} />
                        <WallpaperSwitch checked={checked} onChange={handleChangeTheme} />
                        <Select labelId="label" id="select" value={selectLanguaje} onChange={handleChange}>
                            <MenuItem value="es">Español</MenuItem>
                            <MenuItem value="en">English</MenuItem>
                        </Select>
                    </Toolbar>
                </AppBar>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', md: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
                
                <Drawer
                    anchor="right"
                    variant="permanent"
                    open
                    sx={{
                        display: { xs: 'none', xl: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, height: 'auto' },
                    }}
                >
                    <Toolbar />
                    <Divider />
                    {/*drawerRight*/}
                </Drawer>
            </Box>
        </>
    );
}

ResponsiveDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};
export default ResponsiveDrawer;